import React, { useState, useEffect } from 'react'
import Dropdown from '../components/Dropdown'
import { trainers } from '../constants'
import { Link } from 'react-router-dom'

const Links = () => {

    const [userData, setUserData] = useState('')
    const [course, setCourse] = useState('')
    const [eoi, setEOI] = useState('')
    const [link, setLink] = useState('')


    const links = [
        { id: 'eoi-online', url: `https://upskillinstitute-au.firebaseapp.com/?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'eoi-classroom', url: `https://upskillinstitute-au.firebaseapp.com/?trainerId=${userData.trainerId}&delivery=classroom` },
        { id: 'eoi-traffic-online', url: `https://upskillinstitute-au.firebaseapp.com/trafficControl?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'eoi-traffic-classroom', url: `https://upskillinstitute-au.firebaseapp.com/trafficControl?trainerId=${userData.trainerId}&delivery=classroom` },
        { id: 'eoi-traffic-implement-online', url: `https://upskillinstitute-au.firebaseapp.com/trafficImplementation?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'eoi-traffic-implement-classroom', url: `https://upskillinstitute-au.firebaseapp.com/trafficImplementation?trainerId=${userData.trainerId}&delivery=classroom` },

        { id: 'dec-online', url: `https://upskillinstitute-au.firebaseapp.com/declaration?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'dec-classroom', url: `https://upskillinstitute-au.firebaseapp.com/declaration?trainerId=${userData.trainerId}&delivery=classroom` },

        { id: 'dec-traffic-online', url: `https://upskillinstitute-au.firebaseapp.com/dec-trafficControl?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'dec-traffic-classroom', url: `https://upskillinstitute-au.firebaseapp.com/dec-trafficControl?trainerId=${userData.trainerId}&delivery=classroom` },
        { id: 'dec-traffic-implement-online', url: `https://upskillinstitute-au.firebaseapp.com/dec-trafficImplementation?trainerId=${userData.trainerId}&delivery=online` },
        { id: 'dec-traffic-implement-classroom', url: `https://upskillinstitute-au.firebaseapp.com/dec-trafficImplementation?trainerId=${userData.trainerId}&delivery=classroom` },
    ]

    useEffect(() => {
        if (course && eoi && userData) {
            const linkId = ((eoi.value === 'EOI' ? 'eoi-' : 'dec-') + courses.find(r => r.name === course.value).id + '-classroom').replace('--', '-')
            setLink(links.find(r => r.id === linkId).url.replace('undefined', trainers.find(r => r.name === userData.value).trainerId))
        }
    }, [course, eoi, userData])


    const courses = [
        { id: '', name: 'White Card' },
        { id: 'traffic', name: 'Traffic Control' },
        { id: 'traffic-implement', name: 'Traffic Implement' },
    ]

    const formOptions = ['EOI', 'Declaration']

    return (<div className='form-wrapper'>
        <Dropdown options={trainers.map(r => r.name)} value={userData} setValue={setUserData} label={'Trainer Name'} errorFields={[]} name={'user'} />
        <Dropdown options={courses.map(r => r.name)} value={course} setValue={setCourse} label={'Course'} errorFields={[]} name={'course'} />
        <Dropdown options={formOptions} value={eoi} setValue={setEOI} label={'Form'} errorFields={[]} name={'form'} />
        <br />
        <a href={link} target='_blank' rel='noreferrer'>{link}</a>
        <br />
        <p>
            Restore session?
            <Link to="/student-sessions" className="studentLlnNextButton" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'none' }}> Log back in</Link>
        </p>
    </div>)
}

export default Links
